"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineOneEntry = void 0;
const productsApi_1 = require("./products/productsApi");
const pagesApi_1 = require("./pages/pagesApi");
const productStatusesApi_1 = require("./product-statuses/productStatusesApi");
const templatesApi_1 = require("./templates/templatesApi");
const templatesPreviewApi_1 = require("./templates-preview/templatesPreviewApi");
const adminsApi_1 = require("./admins/adminsApi");
const GeneralTypesApi_1 = require("./general-types/GeneralTypesApi");
const localesApi_1 = require("./locales/localesApi");
const menusApi_1 = require("./menus/menusApi");
const formsApi_1 = require("./forms/formsApi");
const formsDataApi_1 = require("./formsData/formsDataApi");
const fileUploadingApi_1 = require("./file-uploding/fileUploadingApi");
const systemApi_1 = require("./system/systemApi");
/**
 * Define API.
 * @param {string} url - URl of your project.
 * @returns {IDefineApi} - List of methods set.
 */
function defineOneEntry(url, token) {
    const Admins = new adminsApi_1.default(url, token);
    const FileUploading = new fileUploadingApi_1.default(url, token);
    const Forms = new formsApi_1.default(url, token);
    const FormData = new formsDataApi_1.default(url, token);
    const GeneralTypes = new GeneralTypesApi_1.default(url, token);
    const Locales = new localesApi_1.default(url, token);
    const Menus = new menusApi_1.default(url, token);
    const Pages = new pagesApi_1.default(url, token);
    const Products = new productsApi_1.default(url, token);
    const ProductStatuses = new productStatusesApi_1.default(url, token);
    const System = new systemApi_1.default(url, token);
    const Templates = new templatesApi_1.default(url, token);
    const TemplatePreviews = new templatesPreviewApi_1.default(url, token);
    return {
        Admins,
        FileUploading,
        Forms,
        FormData,
        GeneralTypes,
        Locales,
        Menus,
        Pages,
        Products,
        ProductStatuses,
        System,
        Templates,
        TemplatePreviews
    };
}
exports.defineOneEntry = defineOneEntry;
